<template>
  <div class="drag-tip" aria-hidden="true">
    <p class="txt">{{ txt||"继续滑动查看图文详情" }}</p>
  </div>
</template>

<style lang="scss" scoped src="./index.scss"></style>
<script>
export default{
  props:{
    txt:String
  }
}
</script>